var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"wrapper"},[(_vm.chartData!=null)?_c('highcharts',{ref:"chartComponent",attrs:{"options":_vm.chartData}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }